import React from 'react';
import { Apple, Play, Star, Check } from 'lucide-react';
import Reveal from './Reveal';

const StoreButton = ({ icon: Icon, top, bottom, href, comingSoon }) => {
  const base = "relative flex items-center gap-3 rounded-xl bg-[#0E0E11] border border-white/15 px-5 py-2.5 transition-colors duration-200";
  const inner = (
    <>
      <Icon size={24} className="text-white" />
      <div className="text-left leading-tight">
        <div className="text-[10px] text-gray-400">{top}</div>
        <div className="text-white font-semibold text-sm">{bottom}</div>
      </div>
      {comingSoon && (
        <span className="absolute -top-2 -right-2 bg-[var(--ydd-yellow)] text-[#0E0E11] text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide">
          Coming soon
        </span>
      )}
    </>
  );
  if (comingSoon) {
    return (
      <div className={`${base} opacity-70 cursor-default select-none`} aria-disabled="true" title="Coming soon">
        {inner}
      </div>
    );
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={`${base} hover:border-[var(--ydd-yellow)]`}>
      {inner}
    </a>
  );
};

const DownloadCTA = () => {
  return (
    <section id="download" className="py-24">
      <div className="container-ydd">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] bg-[var(--ydd-yellow)] px-8 md:px-16 py-16 md:py-20">
            {/* decorative circles */}
            <div className="pointer-events-none absolute -top-16 -right-10 w-64 h-64 rounded-full bg-black/5" />
            <div className="pointer-events-none absolute -bottom-24 -left-10 w-80 h-80 rounded-full bg-black/5" />
            <div className="relative max-w-2xl">
              <div className="flex items-center gap-2 text-[#0E0E11]/70 text-sm font-semibold">
                <Star size={16} className="fill-[#0E0E11]" /> 4.6 · 10K+ downloads
              </div>
              <h2 className="font-display text-[#0E0E11] text-3xl md:text-5xl mt-4 leading-tight">Start reading, earning &amp; saving today</h2>
              <p className="text-[#0E0E11]/75 mt-5 text-lg font-medium">Download YDD News and turn your daily reading habit into real rewards from your favourite brands.</p>
              <div className="flex flex-wrap gap-4 mt-8">
                <StoreButton icon={Play} top="GET IT ON" bottom="Google Play" href="https://play.google.com/store/apps/details?id=com.ydd.app&hl=en_IN" />
                <StoreButton icon={Apple} top="Download on the" bottom="App Store" comingSoon />
              </div>
              <div className="flex flex-wrap gap-x-6 gap-y-2 mt-8">
                {['No sign-up hassle', 'Free forever', 'Redeem instantly'].map((b) => (
                  <span key={b} className="flex items-center gap-1.5 text-[#0E0E11] text-sm font-semibold">
                    <Check size={16} /> {b}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default DownloadCTA;
